module.exports = __webpack_public_path__ + "static/media/70s.c623b39e.png";